import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'district-ui-client/services/student-events'
import type { StatsScope } from 'district-ui-client/utils/student-events/stats-scope'

export interface AwardsEarnedResponse {
  awards_earned: {
    gold: number
    silver: number
    bronze: number
  }
}

export type AwardsEarnedData = AwardsEarnedResponse['awards_earned']

export async function awardsEarned(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex | LegacyProductMs,
  scope: StatsScope,
  period: NormalizedInterval,
): Promise<Nullable<AwardsEarnedData>> {
  if (isEmpty(scope.ids)) return null

  const url = this.buildUrl('awards_earned', product, scope)
  const query = this.buildQuery(scope, period)

  const data = await this.fetchData<AwardsEarnedResponse>(url, query)
  if (!data) return null

  const { awards_earned } = data
  if (awards_earned.gold + awards_earned.silver + awards_earned.bronze === 0) return null

  return awards_earned
}
